// extracted by mini-css-extract-plugin
export default {"orContainer":"app-login_orContainer__94VXa"};